<template>
  <div>
    <v-btn color="primary"
           @click.stop="dialog = true"
    >
      <v-icon class="margin-right-small">mdi-plus-circle</v-icon>
      Add surround channel mapping
    </v-btn>
    <v-dialog v-model="dialog"
              max-width="500"
              persistent
    >
      <SurroundChannelMappingForm
        v-if="dialog"
        :surroundChannelMappings="surroundChannelMappings"
        :mapping="{ l: 0, c: 1, r: 2, ls: 3, rs: 4, lfe: 5 }"
        :title="'Add Surround Channel Mapping'"
        :clickAction="addSurroundChannelMapping"
        :disableChannelCountEdit="false"
        @cancel="dialog = false"
      ></SurroundChannelMappingForm>
    </v-dialog>
  </div>
</template>

<script>
import SurroundChannelMappingForm from "./SurroundChannelMappingForm";
import { HubConnection } from "@microsoft/signalr";

export default {
  name:       "AddSurroundChannelMapping",
  components: { SurroundChannelMappingForm },
  props:      {
    connection:              HubConnection,
    surroundChannelMappings: Object
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    addSurroundChannelMapping(channelCount, mapping) {
      this.connection
        .invoke("AddSurroundChannelMapping", channelCount, mapping)
        .then((response) => {
          if (response.resultKind === "Success") {
            this.$emit("surround-mappings-updated", response.entity);
            this.dialog = false;
          } else {
            this.$emit("failure", response.reason);
          }
        })
        .catch((response) => {
          this.$emit("failure", response);
        });
    },
  },
};
</script>

<style scoped></style>
